import { render, staticRenderFns } from "./LanguageRating.vue?vue&type=template&id=af7bd700&"
import script from "./LanguageRating.vue?vue&type=script&lang=js&"
export * from "./LanguageRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports